import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { environment as env } from '../../../environments/environment';
@Injectable({ providedIn: "root" })
export class AdapterService {
  onLocalStorageSet = new Subject<boolean>();
  onSessionStorageSet = new Subject<boolean>();

  onLocalStorageRemove = new Subject<boolean>();
  onSessionStorageRemove = new Subject<boolean>();

  onLocalStorageClear = new Subject<boolean>();
  onSessionStorageClear = new Subject<boolean>();

  getLocalStorageValue(key: string): any {
    if (window.localStorage && key) {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    }
    return null;
  };

  setLocalStorageValue(key: string, value: any) {
    if (window.localStorage && key) {
      window.localStorage.setItem(key, JSON.stringify(value));
      this.onLocalStorageSet.next(true);
    }
  };

  removeLocalStorageValue(key: string) {
    if (window.localStorage && key) {
      window.localStorage.removeItem(key);
      this.onLocalStorageRemove.next(true);
    }
  };

  clearLocalStorage() {
    if (window.localStorage) {
      window.localStorage.clear();
      this.onLocalStorageClear.next(true);
    }
  };

  getSessionStorageValue(key: string): any {
    if (window.sessionStorage && key) {
      const value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    }
    return null;
  };

  setSessionStorageValue(key: string, value: any) {
    if (window.sessionStorage && key) {
      window.sessionStorage.setItem(key, JSON.stringify(value));
      this.onSessionStorageSet.next(true);
    }
  };

  removeSessionStorageValue(key: string) {
    if (window.sessionStorage && key) {
      window.sessionStorage.removeItem(key);
      this.onSessionStorageRemove.next(true);
    }
  };

  clearSessionStorage() {
    if (window.sessionStorage) {
      window.sessionStorage.clear();
      this.onSessionStorageClear.next(true);
    }
  };

  checkHasStorageValue(key: string): boolean {
    return !!this.getSessionStorageValue(key) || !!this.getLocalStorageValue(key);
  }

  getStorageOption(isLocal: boolean): Storage {
    return isLocal ? window.localStorage : window.sessionStorage;
  };

  getStorageValue(key: string): any {
    return this.getSessionStorageValue(key) || this.getLocalStorageValue(key);
  }

  removeStorageValue(key: string) {
    this.removeSessionStorageValue(key);
    this.removeLocalStorageValue(key);
  }


  setUpCredentials(response) {
    this.setLocalStorageValue(env.storageKeys.fichas, response.fichas);
    this.setLocalStorageValue(env.storageKeys.user, JSON.stringify(response.entity));

   

    
  }
}
